import { useState, useCallback } from 'react';
import { GrouperView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Hook for managing base rate grouper dialog state
 */
export function useGrouperDialog() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingGrouper, setEditingGrouper] = useState<GrouperView | null>(null);
  const [helpDialogOpen, setHelpDialogOpen] = useState(false);

  const handleAddGrouper = useCallback(() => {
    setEditingGrouper(null);
    setDialogOpen(true);
  }, []);

  const handleEditGrouper = useCallback((grouper: GrouperView) => {
    setEditingGrouper(grouper);
    setDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setDialogOpen(false);
    setEditingGrouper(null);
  }, []);

  const handleOpenHelpDialog = useCallback(() => {
    setHelpDialogOpen(true);
  }, []);

  const handleCloseHelpDialog = useCallback(() => {
    setHelpDialogOpen(false);
  }, []);

  return {
    dialogOpen,
    editingGrouper,
    helpDialogOpen,
    handleAddGrouper,
    handleEditGrouper,
    handleCloseDialog,
    handleOpenHelpDialog,
    handleCloseHelpDialog,
  };
}
